import { useEffect, useState} from 'react'
import { Item } from './../table/Style'
import * as SG from '../../style/Styles'
import * as TXT from './../../util/Texts'
import * as I from './../../util/UrlHttp'
import { SUCCESS_INFO, ERROR_ALERT, SUCCESS_ALERT, } from '../../util/AlertsMsg'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

import * as GameService from './../../services/Game.service'
import * as F from './../../util/Functions'

export default function BlockGame({id, infosData, teamHome, teamVisit, iconHome, iconVisit, homeID, VisitID, hasResult, resultMatch, setResultMatch, isResult, isDash, teams, setReloadMatchs, passed }:any) {

  const [home, setHome]         = useState<any>('')
  const [visit, setVisit]       = useState<any>('')
  const [disabled, setDisabled] = useState<boolean>(false)
  const [score, setScore]       = useState<number>(0)
  const [ac_, setAc_]           = useState<number>(0)
  const [dg_, setDg_]           = useState<number>(0)
  const [pc_, setPc_]           = useState<number>(0)
  const [pp_, setPp_]           = useState<number>(0)
  const [pv_, setPv_]           = useState<number>(0)
  const [rTitle, setRTitle]     = useState<string>('')
  const [rTxt, setRtxt]         = useState<string>('')
  const [open, setOpen]         = useState(false)
  const [newTeam, setNewTeam]   = useState<string>('')
  const [typeChange, setTypeChange]= useState<number>(0)

  const changeValue = (newValue:any, tp:number) => {

    let found = false

    try {
      newValue  = parseInt(newValue)
    } catch (error) {
      console.warn(error)
    }

    let results = resultMatch.map( (value:any, index:any) => {

      if (value.id === id) {
        if (tp === 1)
          value.bet.home = newValue > 99 ? 99 : newValue
        else
          value.bet.visit = newValue > 99 ? 99 : newValue

        found = true
      }

      return value
    })

    if (found === false) {
      
      results.push({"id": id, "bet": { "home": tp === 1 ? newValue : '' , "visit":  tp === 2 ? newValue : '' }})

    } 

    if (newValue > 99) 
      SUCCESS_INFO(TXT.MAX_NUMBER_ACCEPTED)
  
    setResultMatch(results)
  }

  const setValueMatch = (tp:number) => {

    if (resultMatch) {
      let filt = resultMatch.filter( (value:any, index:any) => {

        if( value.id === id)
          return value

        return null
      })

      if(filt.length > 0) {


        if (isResult === false && filt[0].bet.points) {
          setScore(filt[0].bet.points)

          if(filt[0].bet.ac === 1) {
            setRTitle('AC')
            setRtxt(TXT.P_AC)
          }
          if(filt[0].bet.dg === 1) {
            setRTitle('DG')
            setRtxt(TXT.P_DG)
          }
          if(filt[0].bet.pc === 1) {
            setRTitle('PC')
            setRtxt(TXT.P_PC)
          }
          if(filt[0].bet.pp === 1) {
            setRTitle('PP')
            setRtxt(TXT.P_PP)
          }
          if(filt[0].bet.pv === 1) {
            setRTitle('PV')
            setRtxt(TXT.P_PV)
          }

          // setAc_(filt[0].bet.ac)
          // setDg_(filt[0].bet.dg)
          // setPc_(filt[0].bet.pc)
          // setPp_(filt[0].bet.pp)
          // setPv_(filt[0].bet.pv)
        }

        if(tp === 1) 
          return filt[0].bet.home
        else
          return filt[0].bet.visit
      }
    }

    return ''
  }

  const golsMatchs = () => {

    setHome(setValueMatch(1))
    setVisit(setValueMatch(2))

    if (homeID === 0 || VisitID === 0 || isDash === true || hasResult === true || ( passed && passed === true))
      setDisabled(true)
    else 
      setDisabled(false)

  }

  const saveNewTeam = async () => {

    if(typeChange === 0) {
      ERROR_ALERT(TXT.UNEXPECTED_ERROR)

      setTimeout(()=>{
        window.location.reload()
      },2000)
      return false
    }

    if (newTeam === "") {
      ERROR_ALERT(TXT.SELECT_TEAM)
      return false
    }

    try {

      const data:any = {typeChange:typeChange, newTeamId: newTeam, gameId: id, userId: F.GetIDUser()}
      const result   = await GameService.ChangeTeamMatch(data)

      if (result.data) {

        if (result.status == 200) {
          setOpen(false)
          SUCCESS_ALERT(result.data.message)
          setReloadMatchs(true)
        }
        else
          ERROR_ALERT(result.data.message)

      } 

    } catch (error) {

      console.warn(error)
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)

    }

    return
  }

  const checkIfOpen = (tp:number) => {

    const usTp = F.GetUserType();

    if(id > 48 && usTp !== 3) {
      setTypeChange(tp)
      setOpen(true)
    }
    
    return
  }


  useEffect( ()=> {

    golsMatchs()
    
  }, [resultMatch])


  return (
    <Item className='BlockGameItem'>

      <SG.InfoMatch className='InfoMatch'>
        {infosData}
        { rTxt !== '' && <span className='rigres deskI' data-title={rTxt}><p>{rTitle}</p></span> }
      </SG.InfoMatch>
      
      <SG.BoxMatch className='BoxMatch'>

        { rTxt !== '' && <span className='rigres mobI' data-title={rTxt}><p>{rTitle}</p></span> }
        
        <SG.BoxMatchTeam className='BoxMatchTeam'>
          <div className='BoxMatchPerTeam'>
            <SG.CenterItem onClick={()=>{checkIfOpen(1)}}>
              <SG.IconFlag className='IconFlag' src={`${I.BASE_BACK}${iconHome}`} alt={teamHome} />
            </SG.CenterItem>
            <SG.TEAM style={{flex:5}}>{teamHome}</SG.TEAM>
            <SG.InputMatch 
              data-testid="input1"
              type='number'
              min="0" 
              value={home}
              disabled={disabled}
              onChange={(e)=> {changeValue(e.target.value, 1)}}
            />
          </div>

          <SG.TEAM>X</SG.TEAM>

          <div className='BoxMatchPerTeam'>
            <SG.InputMatch 
              data-testid="input2"
              type='number'
              min="0" 
              max="30"
              value={visit}
              disabled={disabled}
              onChange={(e)=> {changeValue(e.target.value, 2)}}
            />
            <SG.TEAM style={{flex:5}}>{teamVisit}</SG.TEAM>
            <SG.CenterItem onClick={()=>{checkIfOpen(2)}}>
              <SG.IconFlag className='IconFlag' src={`${I.BASE_BACK}${iconVisit}`} alt={teamVisit} />
            </SG.CenterItem>
          </div>
        </SG.BoxMatchTeam>


        {isResult === false && ( hasResult ? (<p>{TXT.SCORE} {score}</p>):(<p>{TXT.NOT_MATCH}</p>)) }
      </SG.BoxMatch>

      {open && 
        <Dialog open={open} onClose={()=> setOpen(false) }>
            <DialogTitle className='titleAlertChangePass'>{TXT.CHANGE_TEAM}</DialogTitle>
            <DialogContent>
              <DialogContentText className='dialogText'>
                {TXT.SELECT_TEAM_FOR_MATCH}
              </DialogContentText>
    
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{TXT.TEAM}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={newTeam}
                  label={TXT.TEAM}
                  onChange={(e) => {setNewTeam(e.target.value)}}
                >
                  {teams && teams.length > 0 && 
                    teams.map((item:any) => (
                      <MenuItem key={item.id} value={item.id}>{F.translateTeamName(item.name)}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
    
            </DialogContent>
    
            <DialogActions>
              <Button className='btnDialogClose' onClick={()=> setOpen(false)}>{TXT.CLOSE}</Button>
              <Button className='btnDialog' onClick={saveNewTeam}>{TXT.SAVE}</Button>
            </DialogActions>
    
          </Dialog>
      }
  

    </Item>
  );

}


